(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Darius, Trifarian": {
      triggers: [{
        on: "finalizedCard",
        condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "playedExactly", n: 2 }, { k: "evOther" }] },
        label: "second card: +2 Might & ready",
        program: [
          buff("source", 2),
          { op: "ready", to: "source" },
        ],
      }],
    },

    "Noxian Guillotine": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Choose a unit" }],
      play: [
        {
          op: "if", cond: { k: "legion", n: 2 },
          then: [{ op: "kill", to: "$t" }],
          else: [{ op: "delayed", on: "takeDamage", forEach: "$t", label: "Kill {target} on next damage", program: [{ op: "kill", to: "$ev" }] }],
        },
      ],
    },

    "Hand of Noxus": {
      legendAdd: { energy: 1, requires: "legion" },
    },

    "Noxus Hopeful": {
      costMod: { k: "legion", energyLess: 2 },
    },

    "Disintegrate": {
      targets: [{ bind: "t", spec: { type: "unit", atBf: true }, prompt: "Deal 3 to a unit at a battlefield" }],
      play: [
        { op: "deal", to: "$t", n: 3 },
        { op: "if", cond: { k: "targetDead", bind: "t" }, then: [{ op: "draw", n: 1 }] },
      ],
    },

    "Get Excited!": {
      targets: [{ bind: "t", spec: { type: "unit", atBf: true }, prompt: "Deal the discarded card's Energy cost to a unit at a battlefield" }],
      play: [
        { op: "discard", n: 1, bind: "d" },
        { op: "deal", to: "$t", n: { energyOf: "$d" } },
      ],
    },

    "Dangerous Duo": {
      play: [{
        op: "if", cond: { k: "legion" }, then: [
          { op: "choose", bind: "t", spec: { type: "unit" }, prompt: "Give a unit +2 might this turn" },
          { op: "grant", to: "$t", might: 2 },
        ],
      }],
    },

    "Scrapyard Champion": {
      play: [{
        op: "if", cond: { k: "legion" }, then: [
          { op: "discard", n: 2 },
          { op: "draw", n: 2 },
        ],
      }],
    },

    "Kadregrin the Infernal": {
      play: [{ op: "draw", n: { count: { type: "unit", friendly: true, minMight: 5 } } }],
    },

    "Kai'Sa, Survivor": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "adapt",
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Captain Farron": {
      auraKwSpecs: [{ name: "assault", value: 1, scope: "hereBf", excludeSelf: true }],
    },

    "Raging Soul": {
      selfKwSpecs: [{ name: "assault", value: 1, cond: { k: "discardedThisTurn" } }, { name: "ganking", value: null, cond: { k: "discardedThisTurn" } }],
    },

    "Draven, Showboat": {
      selfMight: function (state, iid) {
        return state.players[state.objs[iid].controller].points;
      },
    },

    "Magma Wurm": { auraEntersReady: true },

    "Sky Splitter": {
      costMod: { k: "highestFriendlyMight", min: 0 },
      targets: [{ bind: "t", spec: { type: "unit", atBf: true }, prompt: "Deal 5 to a unit at a battlefield" }],
      play: [{ op: "deal", to: "$t", n: 5 }],
    },

    "Noxus Saboteur": { blockHiddenReveal: true },

    "Thermo Beam": {
      play: [{ op: "kill", spec: { type: "gear" } }],
    },

    "Shakedown": {
      targets: [{ bind: "t", spec: { type: "unit", enemy: true }, prompt: "Shake down which enemy unit?" }],
      play: [
        { op: "option", byOpponent: true, prompt: "Shakedown: let them draw 2, or your unit takes 6", options: ["My unit takes 6", "They draw 2"], varKey: "sh" },
        { op: "if", cond: { k: "varEq", key: "sh", value: 1 }, then: [{ op: "draw", n: 2 }], else: [{ op: "deal", to: "$t", n: 6 }] },
      ],
    },

    "Stormbringer": {
      targets: [
        { bind: "a", spec: { type: "unit", friendly: true, inBase: true }, prompt: "Choose a friendly unit in your base" },
        { bind: "b", spec: { zone: "battlefield" }, prompt: "Strike which battlefield?" },
      ],
      play: [
        { op: "deal", spec: { type: "unit", enemy: true }, at: "$b", n: { mightOf: "$a" } },
        { op: "move", to: "$a", destBind: "b" },
      ],
    },

    "Iron Ballista": {
      entersExhausted: true,
      abilities: [{
        label: "Exhaust: deal 2 to a unit at a battlefield", exhausts: true,
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", atBf: true }, prompt: "Deal 2 to which unit?" },
          { op: "deal", to: "$t", n: 2 },
        ],
      }],
    },

    "Loose Cannon": {
      triggers: [{
        on: "beginningPhase", you: true, label: "scrounge",
        condSpec: { k: "handMax", n: 1 },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Relentless Storm": {
      triggers: [{
        on: "played", you: true, label: "storm's bounty",
        condSpec: { k: "and", conds: [{ k: "selfReady" }, { k: "evType", type: "unit" }, { k: "evMightAtLeast", n: 5 }] },
        program: [{
          op: "may", prompt: "Exhaust Relentless Storm to channel 1 rune exhausted?", then: [
            { op: "exhaust", to: "source" },
            { op: "channel", n: 1, exhausted: true },
          ],
        }],
      }],
    },

    "Flame Chompers": {
      trashTriggers: [{
        on: "discarded", label: "play me for 1 Fury", optional: true,
        condSpec: { k: "evSelfOrTrashed" },
        program: [
          { op: "payCost", cost: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] }, skipOnFail: 1 },
          { op: "playFrom", to: "source", waive: "all" },
        ],
      }],
    },

    "Unlicensed Armory": {
      abilities: [{
        cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
        exhausts: true, costDiscard: 1, label: "Unlicensed Armory",
        targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Protect which friendly unit?" }],
        program: [{
          op: "optReplaceDeath", to: "$t", dur: "turn",
          cost: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] },
          label: "Unlicensed Armory",
        }],
      }],
    },

    "Blind Fury": {
      play: [{
        op: "lookTopTake", who: "opponent", n: 1, public: true,
        prompt: "Banish and play the revealed card", waive: "all",
      }],
    },

    "Tryndamere, Barbarian": {
      triggers: [{
        on: "unitConquer", self: true, label: "5+ excess damage: score 1",
        condSpec: { k: "excessDamageAtLeast", n: 5 },
        program: [{ op: "points", n: 1 }],
      }],
    },

    "Vayne, Hunter": {
      entersReadyCond: { k: "oppControlsBf" },
      triggers: [{
        on: "unitConquer", self: true, optional: true, label: "return me to hand",
        program: [
          { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0 }, skipOnFail: 1 },
          { op: "toHand", to: "source" },
        ],
      }],
    },

    "Immortal Phoenix": {
      trashTriggers: [{
        on: "dies", optional: true, label: "play me from the trash",
        condSpec: { k: "and", conds: [{ k: "selfInZone", zone: "trash" }, { k: "evKilledByMySpell" }] },
        program: [
          { op: "payCost", cost: { energy: 1, pips: 1, anyPower: 0, domains: ["fury"] }, skipOnFail: 1 },
          { op: "playFrom", to: "source", waive: "all" },
        ],
      }],
    },

    "Volibear, Furious": {
      triggers: [{
        on: "attack", self: true, label: "deal 5 split among enemy units here",
        program: [{ op: "splitDamage", n: 5, spec: { type: "unit", enemy: true, here: true }, prompt: "Split 5 damage" }],
      }],
    },

    "Super Mega Death Rocket!": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Deal 5 to which unit?" }],
      play: [{ op: "deal", to: "$t", n: 5 }],
      trashTriggers: [{
        on: "conquer", you: true, optional: true, label: "discard 1 to return me to hand",
        program: [{ op: "discard", n: 1 }, { op: "toHand", to: "source" }],
      }],
    },

    "Brazen Buccaneer": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Brazen Buccaneer",
          costDiscard: 1,
          discount: { energy: 2, pips: 0, anyPower: 0, domains: null },
        },
      ],
    },

    "Sun Disc": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          requiresLegion: true,
          label: "Sun Disc",
          targets: [],
          program: [{ op: "nextPlayMod", cardType: "unit", mod: "entersReady" }],
        },
      ],
    },

    "Brynhir Thundersong": { play: [{ op: "restrictPlay", who: "opponents", dur: "turn" }] },

    "Raging Firebrand": {
      play: [{ op: "nextPlayMod", cardType: "spell", mod: "costLess", n: 5 }],
    },

    "Ravenborn Tome": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          label: "Ravenborn Tome",
          targets: [],
          program: [{ op: "nextPlayMod", cardType: "spell", mod: "bonusDamage", n: 1 }],
        },
      ],
    },

    "Vi, Destructive": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          costRecycleTrash: 1,
          label: "Vi, Destructive",
          targets: [],
          program: [buff("source", 1)],
        },
      ],
    },

    "Seal of Rage": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] },
            },
          ],
          label: "Add",
        },
      ],
    },

    "Blazing Scorcher": {},

    "Chemtech Enforcer": { play: [{ op: "discard", n: 1 }] },

    "Cleave": {
      play: [{ op: "grant", to: "$t1", keyword: "assault", kwValue: 3, dur: "turn" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give [Assault] to..." }],
    },

    "Daughter of the Void": { legendAdd: { energy: 0, anyPower: 1, domain: null, only: "spell" } },

    "Falling Star": {
      play: [{ op: "deal", to: "$t1", n: 3 }, { op: "deal", to: "$t2", n: 3 }],
      targets: [
        { bind: "t1", spec: { type: "unit" }, prompt: "Deal 3 to..." },
        { bind: "t2", spec: { type: "unit" }, prompt: "Deal 3 to..." },
      ],
    },

    "Hextech Ray": {
      play: [{ op: "deal", to: "$t1", n: 3 }],
      targets: [
        { bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Deal 3 to..." },
      ],
    },

    "Icathian Rain": {
      play: [
        { op: "deal", to: "$t1", n: 2 },
        { op: "deal", to: "$t2", n: 2 },
        { op: "deal", to: "$t3", n: 2 },
        { op: "deal", to: "$t4", n: 2 },
        { op: "deal", to: "$t5", n: 2 },
        { op: "deal", to: "$t6", n: 2 },
      ],
      targets: [
        { bind: "t1", spec: { type: "unit" }, prompt: "Deal 2 to..." },
        { bind: "t2", spec: { type: "unit" }, prompt: "Deal 2 to..." },
        { bind: "t3", spec: { type: "unit" }, prompt: "Deal 2 to..." },
        { bind: "t4", spec: { type: "unit" }, prompt: "Deal 2 to..." },
        { bind: "t5", spec: { type: "unit" }, prompt: "Deal 2 to..." },
        { bind: "t6", spec: { type: "unit" }, prompt: "Deal 2 to..." },
      ],
    },

    "Jinx, Demolitionist": { play: [{ op: "discard", n: 2 }] },

    "Legion Rearguard": {},

    "Pouty Poro": {},

    "Void Seeker": {
      play: [{ op: "deal", to: "$t1", n: 4 }, { op: "draw", n: 1 }],
      targets: [
        { bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Deal 4 to..." },
      ],
    },
  });
})();
